import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/core/services/api-service';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';

@Component({
  selector: 'app-bcpo-file-modal',
  templateUrl: './bcpo-file-modal.component.html',
  styleUrls: ['./bcpo-file-modal.component.scss']
})
export class BcpoFileModalComponent implements OnInit {
  public files: File[] = []
  courtClearanceNumber = new FormControl('')
  policeClearance = new FormControl()
  policeClearanceNumber = new FormControl()
  isLoading: boolean = false
  pdfSrc

  constructor(
    public dialogRef: MatDialogRef<BcpoFileModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
    private api: ApiService,
    private httpClient: HttpClient,
    private evaluatorService: EvaluatorService
  ) { }

  ngOnInit(): void {
    if (this.data.isCourtClearanceRequired) {
      this.courtClearanceNumber.setValidators([Validators.required])
      this.policeClearance.setValidators([Validators.required])
      this.policeClearanceNumber.setValidators([Validators.required])
    }
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  forBcpoProcessing() {
    this.isLoading = true
    this.bcpoForm().subscribe(res => {
      this.isLoading = false
      this.dialogRef.close()
    })
  }

  bcpoForm() {
    const formData: FormData = new FormData();
    formData.append("EvalStatus", "1");
    formData.append("ReasonForChange", "Compliant");
    formData.append("NonCompliantType", '0')
    formData.append("CourtClearanceNumber", this.courtClearanceNumber.value);
    formData.append("PoliceClearanceType", this.policeClearance.value ? this.policeClearance.value : 0);

    this.files.forEach((file, index) => {
      formData.append("Files", file, file.name);
    });

    const url = `/evaluator/update-status/${this.data.id}`;

    return this.api.put(url, formData);
  }

  private async fetchFile(path: string, filename): Promise<File> {
    try {
      const response = await this.httpClient.get(path, { responseType: 'blob' }).toPromise();
      return new File([response], filename, { type: 'application/pdf' });
    } catch (error) {
      console.error('Error fetching file:', error);
      return null;
    }
  }

}
